import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { colors, spacing, styles } = theme.busbud;
  const border_style = `${styles.borderWidth.sm} solid ${colors.border.primary.opaque}`;

  // TODO SSF - duplicated code w/ ticket-option drawer.
  return {
    root: {
      width: "100%",
      height: "100%"
    },
    main: {
      flexGrow: 1
    },
    footer: {
      zIndex: 1, // appear over the bus layout
      position: "sticky",
      bottom: 0,
      right: 0,
      borderTop: border_style,
      borderTopLeftRadius: styles.rounding.xl,
      borderTopRightRadius: styles.rounding.xl,
      backgroundColor: colors.background.primary.opaque // Matches with `Drawer` background
    },
    header: {
      padding: spacing(2.5)
    },
    content: {
      flexGrow: 1
    },
    floorSelector: {
      borderTopLeftRadius: styles.rounding.xl,
      borderTopRightRadius: styles.rounding.xl,
      borderTop: border_style
    },
    busContainer: {
      padding: spacing(
        2,
        2.5,
        0 // No spacing here because `Bus` already has a `marginBottom` (which should be removed)
      )
    }
  };
});
